import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=41acd3af&scoped=true&"
import script from "./changePassword.vue?vue&type=script&lang=ts&"
export * from "./changePassword.vue?vue&type=script&lang=ts&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=41acd3af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41acd3af",
  null
  
)

export default component.exports